module.exports = __webpack_public_path__ + "static/media/show-resumen.3899ccb3.png";